import { Component } from 'react';
import { graphql } from 'react-apollo';
import REFRESH_QUERY from '../../../graphql/Refresh';
import IsGuest from '../../../utils/IsGuest';

class RefreshUser extends Component {
  constructor(props) {
    super(props);

    this.state = {
      intervalId: undefined,
    };
  }


  componentDidMount() {
    const intervalId = setInterval(this.timer, 15000);
    this.setState({ intervalId }); // eslint-disable-line react/no-did-mount-set-state
  }

  componentWillUnmount() {
    clearInterval(this.state.intervalId);
  }

  timer = () => {
    const { refetch } = this.props;

    if (!refetch || IsGuest()) {
      return;
    }

    refetch()
      .then((res) => {
        const { token, user, enabledStats } = res.data.refresh;
        const role = user.type;

        localStorage.setItem('escenaToken', token);
        localStorage.setItem('escenaRole', role);
        localStorage.setItem('escenaStats', enabledStats);
        if (user.theater) {
          localStorage.setItem('escenaTheater', user.theater.id);
          localStorage.setItem('escenaPlan', user.theater.plan);
        }
      });
  };

  render() {
    return this.props.children;
  }
}

const withRefresh = graphql(REFRESH_QUERY, {
  props: ({ data }) => ({
    loading: data.loading,
    refetch: data.refetch,
  }),
});
export default withRefresh(RefreshUser);



// WEBPACK FOOTER //
// ./src/containers/Others/RefreshUser/index.js